<template>
    <div class="shield-modal">
        <b-modal
            :id="id"
            :size="size"
            centered
            :title-class="headerStyle"
            header-bg-variant="banner-background"
            :header-class="headerStyle"
            modal-class="shield-modal"
            :hide-header-close="hideHeaderClose"
            :no-close-on-backdrop="noClose"
            :no-close-on-esc="noClose"
            :hide-footer="hideFooter"
            >

                <template #modal-title>
                    <slot name="title" />
                </template>


                <slot name="default" />


                <template #modal-footer>
                    <b-button
                        v-if="!hideCancel"
                        @click="handleCancel"
                        class="white-button"
                        variant="none"
                    >
                        <slot name="cancel-btn" />
                    </b-button>
                    <b-button
                        @click="handleSubmit"
                        :disabled="!isSubmitEnabled"
                        :class="submitButtonClass? submitButtonClass :'gold-button'"
                        variant="none"
                    >
                        <slot name="submit-btn" />
                    </b-button>
                    <div class="error-blurb">
                        <slot name="error-message"/>
                    </div>
                </template>
        </b-modal>
    </div>

</template>
<script>
import './ShieldModal.scss';
export default ({
    name: 'ShieldModal',
    emits:['handleCancel', 'handleSubmit'],
    props:{
        hideHeaderClose:{
            type: Boolean,
            default: false
        },
        id:{
            type: String,
            default: 'shield-modal'
        },
        size:{
            type: String,
            default: 'md'
        },
        enableSubmit:{
            type: Boolean,
            default: true
        },
        noClose:{
            type: Boolean,
            default: false
        },
        hideCancel:{
            type: Boolean,
            default: false
        },
        hideFooter:{
            type: Boolean,
            default: false
        },
        submitButtonClass: {
            type: String,
            default: ''
        }
    },
    methods:{
        handleCancel(){
            this.$emit('handleCancel');
        },
        handleSubmit(){
            this.$emit('handleSubmit');
        }
    },
    computed:{
        headerStyle(){
            if(this.hideHeaderClose){
                return 'shield-modal-header';
            }
            return 'shield-modal';
        },
        isSubmitEnabled(){
            return this.enableSubmit;
        }
    }

})
</script>
